// extracted by mini-css-extract-plugin
module.exports = {"contact":"_2d_UrT","email":"e6n1WV","shine-lines":"_1nhTp2"};